var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgmInfoWindow } from '@agm/core';
import { ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from 'common/components/base.component';
import { AddressInputComponent } from 'common/components/address.input/address.input.component';
import { HubVisitorFeatureToggle } from 'models/hub/hub.visitor.feature.toggle';
import { HubApiService } from 'services/hub.api.service';
import { AlertifyService } from 'services/alertify.service';
import { HubComponent } from 'components/hub/hub.component';
import { ModalService } from 'common/services/modal.service';
import { ToggleAndDataSourceStore, HubFacebookPageFeedsStore, HubFacebookLocationFeedsStore, } from 'stores/hub.calendar.store';
import { HubFacebookFeedsCommand, } from 'commands/hub/event/add.facebook.general.feed.command';
import { PullGooglePlaceTypeModalActions } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.provider';
import { PullGooglePlaceTypeModalComponent } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component';
import { ConfirmModalData, ConfirmModalActions } from 'common/components/confirm.modal/confirm.modal.provider';
import { ConfirmModalComponent } from 'common/components/confirm.modal/confirm.modal.component';
import { constantTooltip } from 'common/constants/constant.tooltip';
import { ConfigService } from 'services/config.service';
import { AddFacebookLocationFeedCommand } from 'commands/hub/event/add.facebook.location.feed.command';
import { GeoService } from 'services/geo.service';
import { EventPageAdding } from '../../event.add.page';
import { EventLocationAdding } from '../../event.add.location';
import { config } from '../../../../../../config/config';
import { PlaceService } from '../../../../../services/place.service';
import { UpdateGeoLocationStore } from '../../../../../stores/hub.calendar.store';
var SearchGeofenceComponent = /** @class */ (function (_super) {
    __extends(SearchGeofenceComponent, _super);
    function SearchGeofenceComponent(router, formBuilder, hubApiService, activatedRoute, alertify, modalService, parent, renderer, toggleAndDataSourceStore, hubFacebookFeedsStore, updateGeoLocationStore, hubFacebookLocationFeedsStore) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.formBuilder = formBuilder;
        _this.hubApiService = hubApiService;
        _this.activatedRoute = activatedRoute;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.parent = parent;
        _this.renderer = renderer;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.updateGeoLocationStore = updateGeoLocationStore;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.type = 'place';
        _this.eventPage = new EventPageAdding();
        _this.placePageFacebook = new EventPageAdding();
        _this.eventLocation = new EventLocationAdding();
        _this.locationPlaceId = null;
        _this.locationPlaceCityState = null;
        _this.locationSource = 'facebook';
        _this.zoom = ConfigService.config.google.fullUSMapZoom;
        _this.isShowMarker = false;
        _this.isFeedExisted = false;
        _this.isConfirmChecked = false;
        _this.isLoadingFeeds = false;
        _this.inAddingLocationFeed = false;
        _this.isLoadingPlaceSource = false;
        _this.showSuccessInfo = false;
        _this.percentage = '';
        _this.mileToMeters = config.mileToMeters;
        _this.isRepullExistingCategories = false;
        _this.toggles = new HubVisitorFeatureToggle();
        _this.selectedGoogleCategories = [];
        _this.urlSourceItems = [
            {
                text: 'Eventbrite',
                value: 'eventbrite',
            },
            {
                text: 'Eventful',
                value: 'eventful',
            },
        ];
        return _this;
    }
    SearchGeofenceComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.eventPage.tags = 'Visitor Posts';
        this.parent.location = 'Content Management';
        this.pageSource = 'eventbrite';
        this.changeTooltip();
        this.eventFormGroup = this.formBuilder.group({
            facebookPageUrlOrName: [null, [Validators.required]],
            displayTitle: [null, null],
            tags: [null, null],
        });
        this.placeFacebookFormGroup = this.formBuilder.group({
            facebookPageUrlOrName: [null, [Validators.required]],
            displayTitle: [null, null],
            tags: [null, null],
        });
        this.locationFormGroup = this.formBuilder.group({
            address: [null, [Validators.required]],
            displayTitle: [null, null],
            filterByCity: [null, null],
            tags: [null, null],
            radius: [null, [Validators.required]],
        });
        this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            if (toggleCommand.toggle) {
                _this.toggles = toggleCommand.toggle;
                _this.eventLocation.isFilterByCity = _this.toggles.multipleCities;
                if (toggleCommand && toggleCommand.dataSource) {
                    if (_this.type === 'event') {
                        _this.sourceItems = [
                            // Eventbrite had turned the event api off
                            //     {
                            //     text: 'Eventbrite',
                            //     value: 'eventbrite',
                            //     visible: this.toggles.eventByGeolocation
                            // },
                            {
                                text: 'Performers, Venues, Ticketing Websites',
                                value: 'eventful',
                                selected: true,
                                visible: _this.toggles.eventByGeolocation,
                            },
                        ];
                        _this.locationSource = 'eventful';
                    }
                    else if (_this.type === 'place') {
                        if (_this.toggles.placeCalendar) {
                            if (toggleCommand.dataSource.place === 'facebook') {
                                _this.sourceItems = [
                                    {
                                        text: 'Facebook Places',
                                        value: 'facebook',
                                        selected: true,
                                    },
                                ];
                            }
                            else if (toggleCommand.dataSource.place === 'google') {
                                _this.sourceItems = [
                                    {
                                        text: 'Google Places',
                                        value: 'google',
                                        selected: true,
                                    },
                                ];
                            }
                            _this.locationSource = toggleCommand.dataSource.place;
                        }
                    }
                }
            }
        });
        // receive from LocationFeedListComponent to edit a geo-location (adding more categories or delete)
        this.updateGeoLocationStore.updateGeoLocationCommand.takeUntil(this.isDestroyed).subscribe(function (location) {
            if (!location || !location.id)
                return;
            console.log('updateGeoLocation', location);
            _this.eventLocation.lat = location.lat;
            _this.eventLocation.lng = location.lng;
            _this.getLocationStatus();
            _this.showSuccessInfo = false;
            _this.zoom = ConfigService.config.google.locationMapZoom;
            _this.isShowMarker = true;
        });
    };
    Object.defineProperty(SearchGeofenceComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.toggles.manualEvents || this.toggles.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchGeofenceComponent.prototype, "searchGeofenceDisabled", {
        get: function () {
            return ((this.type === 'event' && !this.toggles.eventByGeolocation) ||
                (this.type === 'place' && (!this.toggles.googlePlaceGeofence || !this.toggles.placeCalendar)));
        },
        enumerable: true,
        configurable: true
    });
    SearchGeofenceComponent.prototype.loadLocationFeeds = function () {
        var _this = this;
        if (!this.hubLocations || !this.hubLocations.length) {
            this.isLoadingFeeds = true;
            this.hubApiService.getLocationFeeds(this.hubName).subscribe(function (data) {
                _this.hubLocations = data;
                _this.isLoadingFeeds = false;
            });
        }
    };
    SearchGeofenceComponent.prototype.showCategoryPopup = function () {
        var _this = this;
        var actions = {
            confirm: function (data) {
                var noDuplicated = [];
                var _loop_1 = function (d) {
                    if (!noDuplicated.any(function (x) { return x.value === d.value; })) {
                        noDuplicated.push(d);
                    }
                };
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var d = data_1[_i];
                    _loop_1(d);
                }
                _this.selectedGoogleCategories = noDuplicated.sort(function (a, b) { return a.value.localeCompare(b.value); }); // remove duplicated, as same cateogry may under different types
            },
        };
        this.modalService.show({
            component: PullGooglePlaceTypeModalComponent,
            providers: [{ provide: PullGooglePlaceTypeModalActions, useValue: actions }],
            panelClass: 'width-modal-90p',
        });
    };
    SearchGeofenceComponent.prototype.filterPlacesByCity = function () {
        if (!this.eventLocation.isFilterByCity) {
            this.eventLocation.filterByCity = null;
        }
        else {
            this.eventLocation.filterByCity = this.locationPlaceCityState; //this.locationPlaceId;
        }
    };
    SearchGeofenceComponent.prototype.changeTooltip = function () {
        if (this.pageSource === constantTooltip.facebookString) {
            this.pageTooltip = constantTooltip.facebookTooltip;
        }
        else if (this.pageSource === constantTooltip.eventbriteString) {
            this.pageTooltip = constantTooltip.eventbriteTooltip;
        }
        else if (this.pageSource === constantTooltip.eventfulString) {
            this.pageTooltip = constantTooltip.eventfulTooltip;
        }
    };
    SearchGeofenceComponent.prototype.locationStatus = function () {
        this.showSuccessInfo = false;
        this.getLocationStatus();
    };
    SearchGeofenceComponent.prototype.pageSourceChange = function (target) {
        this.pageSource = target.value;
        this.changeTooltip();
    };
    SearchGeofenceComponent.prototype.findOnMapBySource = function (target) {
        this.locationSource = target.value;
        this.findOnMap();
    };
    SearchGeofenceComponent.prototype.findOnMap = function () {
        if (this.autoCompletedAddress) {
            this.showSuccessInfo = false;
            this.eventLocation.lat = this.autoCompletedAddress.lat;
            this.eventLocation.lng = this.autoCompletedAddress.lng;
            // this.eventLocation.filterByCity = this.eventLocation.isFilterByCity ? this.locationSource === 'eventful' ? this.autoCompletedAddress.cityName : this.autoCompletedAddress.placeId : '';
            this.eventLocation.stateAbbr = this.autoCompletedAddress.stateAbbr;
            this.locationPlaceId =
                this.locationSource === 'eventful' ? this.autoCompletedAddress.cityName : this.autoCompletedAddress.placeId;
            if (this.autoCompletedAddress.country === 'United States') {
                this.locationPlaceCityState = this.autoCompletedAddress.cityName + ", " + this.autoCompletedAddress.stateAbbr;
            }
            else {
                // some city are not the same when you filter place by city
                // e.g., Ibiza Spain, stateAbbr = IB, but if you use Ibiza,IB,Spain to get Google place id, it is different with you use Ibiza,Spain
                this.locationPlaceCityState = this.autoCompletedAddress.cityName + ", " + this.autoCompletedAddress.country;
            }
            this.eventLocation.filterByCity = this.eventLocation.isFilterByCity ? this.locationPlaceCityState : null;
            this.zoom = ConfigService.config.google.locationMapZoom;
            this.isShowMarker = true;
            this.getLocationStatus();
        }
        else {
            this.resetMap();
        }
    };
    SearchGeofenceComponent.prototype.isCategoryExisting = function (category) {
        return this.eventLocation.categories.any(function (x) { return x === category; });
    };
    SearchGeofenceComponent.prototype.addCategoriesToLocation = function (event) {
        var _this = this;
        if (!this.selectedGoogleCategories.length) {
            event && event.immediateComplete();
            this.showCategoryPopup();
            return;
        }
        GeoService.reset();
        var points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, (this.eventLocation.radius * this.mileToMeters) / 1000);
        this.inAddingLocationFeed = true;
        this.hubApiService
            .updateGoogleLocationFeed(this.hubName, {
            id: this.eventLocation.id,
            categories: this.selectedGoogleCategories,
            radius: this.eventLocation.radius,
            isRepullExistingCategories: this.isRepullExistingCategories,
            points: points,
            filterByCity: this.eventLocation.filterByCity,
        })
            .finally(function () {
            event.complete();
        })
            .subscribe(function (data) {
            _this.checkPullingStatus(data);
        });
    };
    SearchGeofenceComponent.prototype.addLocation = function (event) {
        var _this = this;
        if (this.locationSource === 'eventful') {
            alert('This feature is deprecated');
            event.complete();
            return;
        }
        if (!this.isFeedExisted && this.checkIfExceedLimit()) {
            event.complete();
            return;
        }
        this.showSuccessInfo = false;
        if (this.isFeedExisted) {
            if (!this.isConfirmChecked) {
                // shake the confirm checkbox
                this.renderer.addClass(this.confirmCheckbox.nativeElement, 'ig-shake');
                event.immediateComplete();
                setTimeout(function () {
                    _this.renderer.removeClass(_this.confirmCheckbox.nativeElement, 'ig-shake');
                }, 500);
                return;
            }
            this.inAddingLocationFeed = true;
            this.hubApiService
                .removeLocationFeed(this.hubName, this.eventLocation.feedId, this.locationSource)
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                setTimeout(function () {
                    _this.showSuccessInfo = false;
                    _this.infoWindow.close();
                    _this.addressInput.clear();
                    _this.getHubLocations();
                }, 1500);
            });
            return;
        }
        this.inAddingLocationFeed = true;
        if (this.locationSource == 'facebook') {
            // let points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius);
            // console.log(points);
            this.hubApiService
                .addFacebookLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address, this.hubName, this.eventLocation.filterByCity, [], //points,
            this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.stateAbbr, this.eventLocation.tags))
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
                _this.eventLocation.filterByCity = null;
                _this.getHubLocations();
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
            });
        }
        else if (this.locationSource === 'google') {
            GeoService.reset();
            var points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, (this.eventLocation.radius * this.mileToMeters) / 1000);
            console.log("points.length: " + points.length);
            console.log("this.eventLocation.filterByCity: " + this.eventLocation.filterByCity);
            this.hubApiService
                .addGoogleLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address, this.hubName, this.eventLocation.filterByCity, points, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.stateAbbr, this.eventLocation.tags, 'google', this.selectedGoogleCategories.map(function (y) { return y.value; })))
                .finally(function () {
                event.complete();
                _this.eventLocation.filterByCity = null;
                _this.getHubLocations();
            })
                .subscribe(function (data) {
                if (data) {
                    _this.checkPullingStatus(data);
                    // if (data.status === 'under pulling') {
                    //   this.alertify.warning(data.msg);
                    //   this.inAddingLocationFeed = false;
                    // } else if (data.status === 'pulling') {
                    //   let getPullingStatus = setInterval(() => {
                    //     this.hubApiService.checkPullingGooglePlaceStatus(this.hubName).subscribe((data) => {
                    //       if (data && !data.isPulling) {
                    //         clearInterval(getPullingStatus);
                    //         this.inAddingLocationFeed = false;
                    //         this.locationFormGroup.markAsPristine();
                    //         this.showSuccessInfo = true;
                    //         this.percentage = '';
                    //       } else {
                    //         this.percentage = data.progress;
                    //         if (this.percentage && this.percentage.toString().includes('99')) {
                    //           this.percentage += `...Uploading images to AWS`;
                    //         }
                    //       }
                    //     });
                    //   }, 10000);
                    // }
                }
                event.complete();
            });
        }
        else if (this.locationSource == 'eventbrite') {
            this.hubApiService
                .addEventBriteLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address, this.hubName, null, null, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.tags, config.eventbrite))
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                _this.getHubLocations();
            });
        }
        else if (this.locationSource == 'eventful') {
            this.hubApiService
                .addEventfulLocationFeed(this.hubName, new AddFacebookLocationFeedCommand(this.eventLocation.address, this.eventLocation.displayTitle ? this.eventLocation.displayTitle : this.autoCompletedAddress.address, this.hubName, this.eventLocation.filterByCity, null, this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius, this.eventLocation.stateAbbr, this.eventLocation.tags, 'eventful'))
                .finally(function () {
                event.complete();
                _this.inAddingLocationFeed = false;
            })
                .subscribe(function () {
                _this.locationFormGroup.markAsPristine();
                _this.showSuccessInfo = true;
                _this.getHubLocations();
            });
        }
    };
    SearchGeofenceComponent.prototype.toReadable = function (code) {
        return PlaceService.toReadableCategory(code);
    };
    SearchGeofenceComponent.prototype.checkPullingStatus = function (status) {
        var _this = this;
        if (status.status === 'under pulling') {
            this.alertify.warning(status.msg);
            this.inAddingLocationFeed = false;
        }
        else if (status.status === 'pulling') {
            var getPullingStatus_1 = setInterval(function () {
                _this.hubApiService.checkPullingGooglePlaceStatus(_this.hubName).subscribe(function (data) {
                    if (data && !data.isPulling) {
                        clearInterval(getPullingStatus_1);
                        _this.inAddingLocationFeed = false;
                        _this.locationFormGroup.markAsPristine();
                        _this.showSuccessInfo = true;
                        _this.percentage = '';
                    }
                    else {
                        _this.percentage = data.progress;
                        if (_this.percentage && _this.percentage.toString().includes('99')) {
                            _this.percentage += "...Uploading images to AWS";
                        }
                    }
                });
            }, 10000);
        }
    };
    SearchGeofenceComponent.prototype.checkIfExceedLimit = function () {
        // only restrict event page limit now
        if (this.locationSource === 'google')
            return false;
        if (this.hubLocations && this.hubLocations.length) {
            var isExceedLimit = false;
            // adding place location feed
            // if (this.locationSource === 'facebook' || this.locationSource === 'google') {
            if (this.locationSource === 'facebook') {
                //     if (this.hubLocations.filter(x => x.socialName === 'facebook' || x.socialName === 'google').length >= config.maxLocationFeedLimit) {
                if (this.hubLocations.filter(function (x) { return x.socialName === 'facebook'; }).length >= config.maxLocationFeedLimit) {
                    isExceedLimit = true;
                }
            }
            else {
                // adding event location feed
                if (this.hubLocations.filter(function (x) { return x.socialName === 'eventbrite' || x.socialName === 'eventful'; }).length >=
                    config.maxLocationFeedLimit) {
                    isExceedLimit = true;
                }
            }
            if (isExceedLimit) {
                var data = {
                    confirmModalIcon: 'warning',
                    confirmModalTitle: 'Warning',
                    confirmModalDescription: "The number of locations you have added has exceeded the limit, please contact our team, emailing <a href=\"mailto:aline@iti-digital.com\">aline@iti-digital.com</a> or call us at 912-267-1558</p>",
                    confirmModalCancelButtonText: 'OK',
                    isAsync: true,
                };
                var actions = {};
                this.modalService.show({
                    component: ConfirmModalComponent,
                    providers: [
                        { provide: ConfirmModalActions, useValue: actions },
                        { provide: ConfirmModalData, useValue: data },
                    ],
                });
                return true;
            }
        }
        return false;
    };
    SearchGeofenceComponent.prototype.getHubPageFeeds = function () {
        var _this = this;
        var times = 0;
        var getFeeds = function () {
            return _this.hubApiService
                .getPageFeeds(_this.hubName)
                .catch(function (err) {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
                .subscribe(function (data) {
                _this.hubPages = data;
                var pageCommand = new HubFacebookFeedsCommand(data);
                _this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
            });
        };
        getFeeds();
    };
    SearchGeofenceComponent.prototype.getHubLocations = function () {
        var _this = this;
        var times = 0;
        this.isLoadingFeeds = true;
        var getFeeds = function () {
            return _this.hubApiService
                .getLocationFeeds(_this.hubName)
                .catch(function (err) {
                if (times < 3) {
                    getFeeds();
                }
                times++;
                return Observable.throw(err.statusText);
            })
                .subscribe(function (data) {
                _this.isLoadingFeeds = false;
                _this.hubLocations = data;
                _this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(_this.hubLocations));
            });
        };
        getFeeds();
    };
    SearchGeofenceComponent.prototype.getLocationStatus = function () {
        var _this = this;
        this.hubApiService
            .getLocationStatus(this.hubName, this.autoCompletedAddress ? this.autoCompletedAddress.lat : this.eventLocation.lat, this.autoCompletedAddress ? this.autoCompletedAddress.lng : this.eventLocation.lng, this.locationSource)
            .subscribe(function (result) {
            if (result) {
                _this.isFeedExisted = result.connected;
                if (_this.isFeedExisted) {
                    _this.eventLocation.displayTitle = result.title;
                    _this.eventLocation.id = result.feedId;
                }
                else {
                    _this.eventLocation.displayTitle = _this.autoCompletedAddress.address;
                }
                if (result.radius) {
                    _this.eventLocation.radius = result.radius / config.mileToMeters;
                }
                _this.eventLocation.feedId = result.feedId;
                _this.eventLocation.filterByCity = result.filterByCity;
                _this.eventLocation.categories = result.categories.sort(function (a, b) { return a.localeCompare(b); });
            }
        });
    };
    SearchGeofenceComponent.prototype.resetMap = function () {
        this.eventLocation.lat = ConfigService.config.google.USCenter.lat;
        this.eventLocation.lng = ConfigService.config.google.USCenter.lng;
        this.eventLocation.filterByCity = null;
        this.isShowMarker = false;
        this.zoom = ConfigService.config.google.fullUSMapZoom;
    };
    return SearchGeofenceComponent;
}(BaseComponent));
export { SearchGeofenceComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/search.geofence/search.geofence.component.ts.pre-build-optimizer.js